import { titleCase } from '@common/helpers/strings';
import { tocsMap } from '@sly/core/constants/filters';
import slugify from 'slugify';

const s = (name) => slugify(name, { lower: true, strict: true });

export const getTocStateUrl = (toc, state) => {
  const stateSlug = s(state);
  return `${tocsMap[toc].href}/${stateSlug}`;
};

export const getStateSitemapUrls = (cities, state) => {
  const stateSlug = s(state);

  return cities
    .filter(({ typeCare }) => tocsMap[typeCare])
    .sort((a, b) => a.city.name.localeCompare(b.city.name))
    .map(({ typeCare, city }) => {
      const path = `${tocsMap[typeCare].href}/${stateSlug}/${s(city.name)}`;
      return {
        city,
        typeCare,
        title: `${typeCare} Communities in ${titleCase(city.name)}`,
        path,
      };
    });
};

export const getStateCountiesSitemapUrls = (counties, state) => {
  const stateSlug = s(state);
  return counties
    .filter(({ typeCare }) => tocsMap[typeCare])
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(({ typeCare, name }) => {
      const path = `${tocsMap[typeCare].href}/${stateSlug}/${s(name)}-county`;
      return {
        typeCare,
        title: `${titleCase(name)} County ${typeCare}`,
        path,
      };
    });
};
